// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ConfettiController from "./confetti_controller";
application.register("confetti", ConfettiController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import SelectorController from "./selector_controller";
application.register("selector", SelectorController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import TurnstileController from "./turnstile_controller";
application.register("turnstile", TurnstileController);
